import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby";
import useLiveData from 'hooks/useLiveData';
import VerticalTextThreeSlides from 'components/VerticalTextThreeSlides';
import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const VerticalTextThreeSlideProvider = (props) => {

	const { matchAudience } = useContext(PersonalizationContext);

	const data = useStaticQuery(graphql`
		query allSmartTagsVerticalTextThreeSlides {
			allSmartTagsVerticalTextThreeSlides {
				edges {
					node {
						id
						background
						backgroundImage
						backgroundProps
						flush
						padding
						title
						slide1Image
						slide1Label
						slide1Title
						slide1Link
						slide2Image
						slide2Label
						slide2Title
						slide2Link
						slide3Image
						slide3Label
						slide3Title
						slide3Link
						Audience {
						  ...AudienceRelationshipDetailsFragment
						}
						PersonalizationExclude {
						  object {
							id
							Audience {
								...AudienceRelationshipDetailsFragment
							}
						  }
						}
						PersonalizationInclude {
						  object {
							id
							Audience {
								...AudienceRelationshipDetailsFragment
							}
						  }
						}
					}
				}
			}
		}
	`);

	const { response } = useLiveData({
		namespace: 'SmartTags',
		model: 'VerticalTextThreeSlides',
		method: 'all',
		graphqlKey: 'allSmartTagsVerticalTextThreeSlides',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
		},
		staticData: data,
	});

	let attr;
	if (response.data.length !== 0) {
		for (let item of response.data) {
			if (item.id === props.id)attr = item;
		}
	}

	const slides = React.useMemo(() => ([
		{
			title: attr?.slide1Title,
			label: attr?.slide1Label,
			image: attr?.slide1Image,
			link: attr?.slide1Link,
		},
		{
			title: attr?.slide2Title,
			label: attr?.slide2Label,
			image: attr?.slide2Image,
			link: attr?.slide2Link,
		},{
			title: attr?.slide3Title,
			label: attr?.slide3Label,
			image: attr?.slide3Image,
			link: attr?.slide3Link,
		},
	]), [attr?.slide1Image, attr?.slide1Label, attr?.slide1Link, attr?.slide1Title, attr?.slide2Image, attr?.slide2Label, attr?.slide2Link, attr?.slide2Title, attr?.slide3Image, attr?.slide3Label, attr?.slide3Link, attr?.slide3Title]);


	const filteredSlides = slides.filter(obj => {
		return !Object.values(obj).every(value => value === null);
	});

	if (response.data.length === 0)return null;
	if (!attr)return null;
	if (!matchAudience(attr))return null;

	return (
		<VerticalTextThreeSlides slides={filteredSlides} {...attr} matchAudience={matchAudience} />
	)
};

export default VerticalTextThreeSlideProvider;